import { useState, Dispatch, MouseEvent, SetStateAction, ChangeEvent, SyntheticEvent, MutableRefObject } from "react";
import Category from "../Category";
import styles from "./SeletedCategory.module.css";
import { CategoryOptions } from "../../common/Common";
import Icon from "../../common/Icon";

interface SortingStatus {
    sortBy: string;
    direction: string;
}

interface MapAreaProps {
    selectedCategory: number;
    setSelectedCategory: Dispatch<SetStateAction<number>>;
    categories: CategoryOptions[];
    setIsSorting: React.Dispatch<React.SetStateAction<SortingStatus>>;
    prevSelectedCategoryRef?: MutableRefObject<number | null>;
}

/**
 * @author L.chanwoo
 * @date 2024-09-03 16:34:19
 * @remark 선택된 카테고리
 * @returns
 */
const SeletedCategory = (props: MapAreaProps) => {
    const [activeIdx, setActiveIdx] = [props.selectedCategory, props.setSelectedCategory];
    const sortList = [
        {label: "조회수 높은순", direction: "desc", sortBy: "viewCnt"},
        {label: "도움돼요 많은순", direction: "desc", sortBy: "THUMB_CNT"},
        {label: "이름 오름차순", direction: "asc", sortBy: "placeName"},
        {label: "이름 내림차순", direction: "desc", sortBy: "placeName"},
    ];

    const sideCategory = { ...props.categories[activeIdx] };
    sideCategory.isActive = true;
    if (props.selectedCategory === 0) {
        sideCategory.cancel = false;
        sideCategory.icon = "sort";
    } else {
        sideCategory.cancel = true;
        sideCategory.icon = "marker";
    }
    sideCategory.onClick = (e: MouseEvent<HTMLElement>) => {
        e.stopPropagation();
        setActiveIdx(0);
        props.prevSelectedCategoryRef!.current = 0
    };

    const [selectedSort, setSelectedSort] = useState("");
    const onclickSortReset = (e: SyntheticEvent) => {
        setSelectedSort("");
        props.setIsSorting({ sortBy: 'XID', direction: 'asc' });
    };

    const handleFormChange = (e: ChangeEvent<HTMLSelectElement>) => {
        const target = e.target;
        const selectedOption = target.options[target.selectedIndex];
        const sortBy = selectedOption.getAttribute("data-sortby"); 
        const direction = selectedOption.getAttribute("data-direction");

        setSelectedSort(String(target.value));
        props.setIsSorting({ sortBy: sortBy!, direction: direction! });
    };

    return (
        <div className={`${styles["selected-category-container"]}`}>
            <Category {...sideCategory} />
            <div className={`${styles.sortContainer}`}>
                <select
                    className={`${styles.sort_select}`}
                    name="sort"
                    value={selectedSort}
                    onChange={handleFormChange}
                >
                    <option value="" disabled>
                        정렬
                    </option>
                    {sortList.map((sort, idx) => (
                        <option
                            key={idx}
                            value={idx}
                            data-sortby={sort.sortBy}
                            data-direction={sort.direction}
                        >
                        {sort.label}
                        </option>
                    ))}
                </select>
                <button className={`${styles.resetBtn}`} onClick={onclickSortReset}>
                    <Icon name={"reset"} color={"none"} size={"medium"} />
                </button>
            </div>
        </div>
    );
};

export default SeletedCategory;
